import React from "react";

function Socials({ small, socials }) {
  const {
    facebook_url,
    instagram_url,
    twitter_url,
    linkedin_url,
    github_url,
    youtube_url,
  } = socials;

  return (
    <div>
      {small ? (
        <div className="cht-flex cht-flex-wrap cht-items-center cht-justify-center cht-gap-2">
          {facebook_url ? (
            <a
              href={facebook_url}
              target="_blank"
              rel="noopener noreferrer"
              className="cht-w-9 cht-h-9 cht-rounded-xl cht-bg-white/80 hover:cht-bg-[#3e57da] cht-text-slate-600 hover:cht-text-white cht-flex cht-items-center cht-justify-center cht-border cht-border-slate-200/80 cht-shadow-sm cht-transition-all cht-duration-200"
              aria-label="Facebook"
            >
              <i className="fa-brands fa-facebook-f cht-text-sm"></i>
            </a>
          ) : null}

          {instagram_url ? (
            <a
              href={instagram_url}
              target="_blank"
              rel="noopener noreferrer"
              className="cht-w-9 cht-h-9 cht-rounded-xl cht-bg-white/80 hover:cht-bg-[#3e57da] cht-text-slate-600 hover:cht-text-white cht-flex cht-items-center cht-justify-center cht-border cht-border-slate-200/80 cht-shadow-sm cht-transition-all cht-duration-200"
              aria-label="Instagram"
            >
              <i className="fa-brands fa-instagram cht-text-sm"></i>
            </a>
          ) : null}

          {twitter_url ? (
            <a
              href={twitter_url}
              target="_blank"
              rel="noopener noreferrer"
              className="cht-w-9 cht-h-9 cht-rounded-xl cht-bg-white/80 hover:cht-bg-[#3e57da] cht-text-slate-600 hover:cht-text-white cht-flex cht-items-center cht-justify-center cht-border cht-border-slate-200/80 cht-shadow-sm cht-transition-all cht-duration-200"
              aria-label="Twitter"
            >
              <i className="fa-brands fa-x-twitter cht-text-sm"></i>
            </a>
          ) : null}

          {linkedin_url ? (
            <a
              href={linkedin_url}
              target="_blank"
              rel="noopener noreferrer"
              className="cht-w-9 cht-h-9 cht-rounded-xl cht-bg-white/80 hover:cht-bg-[#3e57da] cht-text-slate-600 hover:cht-text-white cht-flex cht-items-center cht-justify-center cht-border cht-border-slate-200/80 cht-shadow-sm cht-transition-all cht-duration-200"
              aria-label="LinkedIn"
            >
              <i className="fa-brands fa-linkedin-in cht-text-sm"></i>
            </a>
          ) : null}

          {youtube_url ? (
            <a
              href={youtube_url}
              target="_blank"
              rel="noopener noreferrer"
              className="cht-w-9 cht-h-9 cht-rounded-xl cht-bg-white/80 hover:cht-bg-[#3e57da] cht-text-slate-600 hover:cht-text-white cht-flex cht-items-center cht-justify-center cht-border cht-border-slate-200/80 cht-shadow-sm cht-transition-all cht-duration-200"
              aria-label="YouTube"
            >
              <i className="fa-brands fa-youtube cht-text-sm"></i>
            </a>
          ) : null}

          {github_url ? (
            <a
              href={github_url}
              target="_blank"
              rel="noopener noreferrer"
              className="cht-w-9 cht-h-9 cht-rounded-xl cht-bg-white/80 hover:cht-bg-[#3e57da] cht-text-slate-600 hover:cht-text-white cht-flex cht-items-center cht-justify-center cht-border cht-border-slate-200/80 cht-shadow-sm cht-transition-all cht-duration-200"
              aria-label="GitHub"
            >
              <i className="fa-brands fa-github cht-text-sm"></i>
            </a>
          ) : null}
        </div>
      ) : (
        <section className="cht-py-16 cht-bg-slate-50/60 cht-border-y cht-border-slate-200/80 !cht-font-body">
          <div className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8">
            <header className="cht-text-center cht-mb-8">
              <span className="cht-inline-flex cht-items-center cht-px-3.5 cht-py-1.5 cht-rounded-full cht-text-xs cht-font-semibold cht-bg-[#3e57da]/10 cht-text-[#3e57da] cht-mb-3 cht-tracking-wide cht-uppercase">
                Connect With Us
              </span>
              <h2 className="cht-text-2xl sm:cht-text-3xl cht-font-bold !cht-font-heading cht-text-[#1e293b]">
                Our Social Communities
              </h2>
              <p className="cht-text-sm sm:cht-text-base cht-text-slate-600 cht-mt-2 cht-max-w-md cht-mx-auto">
                Follow our official channels for real-time announcements, tech insights, and industry updates.
              </p>
            </header>

            <div className="cht-flex cht-flex-wrap cht-justify-center cht-gap-4">
              {facebook_url ? (
                <a
                  href={facebook_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cht-w-14 cht-h-14 cht-rounded-[18px] cht-bg-white cht-border cht-border-slate-200/80 cht-shadow-soft hover:cht-border-[#3e57da] hover:cht-shadow-float cht-flex cht-items-center cht-justify-center cht-text-[#3e57da] hover:cht-scale-105 cht-transition-all cht-duration-200"
                  aria-label="Facebook"
                >
                  <i className="fa-brands fa-facebook-f cht-text-xl"></i>
                </a>
              ) : null}

              {instagram_url ? (
                <a
                  href={instagram_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cht-w-14 cht-h-14 cht-rounded-[18px] cht-bg-white cht-border cht-border-slate-200/80 cht-shadow-soft hover:cht-border-[#3e57da] hover:cht-shadow-float cht-flex cht-items-center cht-justify-center cht-text-[#e1306c] hover:cht-scale-105 cht-transition-all cht-duration-200"
                  aria-label="Instagram"
                >
                  <i className="fa-brands fa-instagram cht-text-xl"></i>
                </a>
              ) : null}

              {twitter_url ? (
                <a
                  href={twitter_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cht-w-14 cht-h-14 cht-rounded-[18px] cht-bg-white cht-border cht-border-slate-200/80 cht-shadow-soft hover:cht-border-[#3e57da] hover:cht-shadow-float cht-flex cht-items-center cht-justify-center cht-text-[#1e293b] hover:cht-scale-105 cht-transition-all cht-duration-200"
                  aria-label="Twitter / X"
                >
                  <i className="fa-brands fa-x-twitter cht-text-xl"></i>
                </a>
              ) : null}

              {linkedin_url ? (
                <a
                  href={linkedin_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cht-w-14 cht-h-14 cht-rounded-[18px] cht-bg-white cht-border cht-border-slate-200/80 cht-shadow-soft hover:cht-border-[#3e57da] hover:cht-shadow-float cht-flex cht-items-center cht-justify-center cht-text-[#0a66c2] hover:cht-scale-105 cht-transition-all cht-duration-200"
                  aria-label="LinkedIn"
                >
                  <i className="fa-brands fa-linkedin-in cht-text-xl"></i>
                </a>
              ) : null}

              {youtube_url ? (
                <a
                  href={youtube_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cht-w-14 cht-h-14 cht-rounded-[18px] cht-bg-white cht-border cht-border-slate-200/80 cht-shadow-soft hover:cht-border-[#3e57da] hover:cht-shadow-float cht-flex cht-items-center cht-justify-center cht-text-[#ff0000] hover:cht-scale-105 cht-transition-all cht-duration-200"
                  aria-label="YouTube"
                >
                  <i className="fa-brands fa-youtube cht-text-xl"></i>
                </a>
              ) : null}

              {github_url ? (
                <a
                  href={github_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cht-w-14 cht-h-14 cht-rounded-[18px] cht-bg-white cht-border cht-border-slate-200/80 cht-shadow-soft hover:cht-border-[#3e57da] hover:cht-shadow-float cht-flex cht-items-center cht-justify-center cht-text-[#24292e] hover:cht-scale-105 cht-transition-all cht-duration-200"
                  aria-label="GitHub"
                >
                  <i className="fa-brands fa-github cht-text-xl"></i>
                </a>
              ) : null}
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

export default Socials;
